export const printConsole = () => {
  console.log(
    `%c

  ____     __     __   U _____ u    ____        ____     U ___ u    ____       ____    
 |  _"\\    \\ \\   /"/u   \|___"|/  U |  _"\\ u  U /"___|     \/"_  \/ U |  _"\\ u  U|  _"\\ u 
/| | | |    \\ \\ / //    |  _|"     \| |_) |/   \| | u      | | | |   \| |_) |/   \| |_) |/ 
U| |_| |\\   /\\ V /_,-.  | |___     |  _ <     | |/__ .-,_| |_| |   |  _ <     |  __/   
 |____/ u  U  \\_/-(_/   |_____|    |_| \_\\      \\____|    \_)-\___/   |_| \_\\     |_|      
  |||_       //         <<   >>    //   \\_     _// \\       \\        //   \\_   ||>>_    
 (__)_)     (__)       (__) (__)  (__)  (__)  (__)(__)     (__)    (__)  (__) (__)__)   

`,
    'color:#005bfe;font-weight:bold'
  );
};
